module.exports = __webpack_public_path__ + "static/media/owen.e3183922.png";